import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faHandHoldingHeart,
  faRightFromBracket,
  faArrowRightToBracket,
  faRightToBracket,
  faAnglesRight,
  faCogs,
  faUser,
  faUsers,
  fas,
} from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCogs, faUser, faUsers, fas, far, fab, faHandHoldingHeart, faAnglesRight, faArrowRightToBracket, faRightToBracket, faRightFromBracket);


export default FontAwesomeIcon;
